export const initialState = {
  assets: [],
  assetsWithoutSeries: [],
  baseDate: null,
  lastUpdateDate: null,
  selectedPeriod: "UM_ANO_UTIL",
  initialApplication: 100,
  selectedTab: 0,
  selectedBenchmarksIndexes: [],
  correlationData: {},
  benchmarkAssets: [],
  isFetchingAssetsSeries: false,
  periodRange: {
    initialDate: null,
    finalDate: null,
  },
  userHasInteractedWithPeriod: false,
};

export * from "./reducer";
export * from "./selectors";
